import { render, staticRenderFns } from "./OtherProducts.vue?vue&type=template&id=61cbe585&"
import script from "./OtherProducts.vue?vue&type=script&lang=js&"
export * from "./OtherProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports